import AxiosClient from "@/repositories/Clients/AxiosClient";

export default {
  ping() {
    return AxiosClient.get("/ping");
  },
  run_chatboql_query(query, thread_id) {
    return AxiosClient.get(
      `/chatboql?input_message=${query}&thread_id=${thread_id}`
    );
  },

  get(url, config = null) {
    return AxiosClient.get(url, config);
  },

  post(url, data = null, config = null) {
    return AxiosClient.post(url, data, config);
  },

  get_schema(schema_name) {
    return AxiosClient.get(`/schema/${schema_name}`);
  },

  run_query(joinStack, queryCols, populationsData) {
    console.log(queryCols);
    return AxiosClient.post(`/query`, {
      joinStack,
      queryCols,
      populationsData,
    });
  },

  get_results_path(params) {
    const {
      table_path,
      sort_field = "",
      sort_order = 1,
      pivotColumn = "",
      pivotValues = "",
      pivotOperator = "",
    } = params;
    return AxiosClient.get(
      `/results_path?table_path=${table_path}&sort_field=${sort_field}&sort_order=${sort_order}&pivot_column=${pivotColumn}&pivot_values=${pivotValues}&pivot_operator=${pivotOperator}`
    );
  },

  get_results(table_path, offset, limit, sort_field = "", sort_order = 1) {
    return AxiosClient.get(
      `/results?table_path=${table_path}&offset=${offset}&limit=${limit}&sort_field=${sort_field}&sort_order=${sort_order}`
    );
  },

  get_plots() {
    return AxiosClient.get("/plots");
  },

  get_populations() {
    return AxiosClient.get("/populations");
  },
};
